import React from 'react';
import { topMatchProps } from '../../Templates/Assessment/Assessment';
import { FormattedMessage } from 'react-intl';
import messages from 'src/apps/maas360-estimator/locales/messages';

type topMatchDataProps = {
  data: topMatchProps;
};

const TopMatch = ({ data }: topMatchDataProps) => {
  return (
    <div className="topmatch_comp">
      <div className="page_sub_heading">
        <FormattedMessage {...messages.top_match} />
      </div>
      <div className="page_heading_3 mar5">{data.title}</div>
      <div className="page_body mt-8">{data.shortDesc}</div>
    </div>
  );
};

export default TopMatch;
